/* Pistacho — o quiz que veste a peça.
 *
 * Uma regra: nenhuma pergunta que não mude o que se está a ver. Por isso não há
 * ecrãs de "estilo" nem barras de personalidade — há a peça, e ela muda.
 *
 * O quiz não tem conteúdo escrito peça a peça. Lê os eixos que cada peça tem
 * mesmo (tecido, madeira, tampo, metal, tamanho...) e faz uma pergunta por cada
 * um, pela ordem em que mudam mais a fotografia. Um banco tem dois eixos, uma
 * cama tem três, uma mesa de apoio tem um.
 */
(function () {
  'use strict';
  var raiz = document.getElementById('qz');
  if (!raiz) return;
  var palco = raiz.querySelector('[data-qz-palco]');
  var carga = raiz.querySelector('[data-qz-carga]');

  var D = null;                       // os dados
  var est = { div: null, peca: null, esc: {}, i: 0, prazo: null };

  function img(u, w) {
    if (!u) return '';
    var full = /^https?:/.test(u) ? u : D.cdn + u;
    return full + (full.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 1200);
  }
  // O preço escreve-se como a loja o escreve. O Intl em pt-PT devolvia "6300 €"
  // — sem separador de milhares, porque o pt-PT só agrupa a partir de cinco
  // dígitos — enquanto a ficha ao lado dizia "€6.300,00". Dois preços com o
  // mesmo valor e duas caras diferentes na mesma compra.
  var MOEDA = raiz.dataset.moneyFormat || '€{{amount_with_comma_separator}}';

  function agrupar(n, milhar, decimal, casas) {
    var v = (Math.round(n * 100) / 100).toFixed(casas);
    var p = v.split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, milhar);
    return p.length > 1 ? p[0] + decimal + p[1] : p[0];
  }

  function euros(n) {
    return MOEDA.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, t) {
      if (t === 'amount') return agrupar(n, ',', '.', 2);
      if (t === 'amount_no_decimals') return agrupar(n, ',', '.', 0);
      if (t === 'amount_with_comma_separator') return agrupar(n, '.', ',', 2);
      if (t === 'amount_no_decimals_with_comma_separator') return agrupar(n, '.', ',', 0);
      if (t === 'amount_with_apostrophe_separator') return agrupar(n, "'", '.', 2);
      return agrupar(n, '.', ',', 2);
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // O quadrado do material. A mesma cor pode estar fotografada de maneira
  // diferente conforme a peça — o carvalho de um aparador não é a mesma foto
  // que o carvalho de uma cama — por isso o da própria peça manda, e o geral
  // só serve de rede.
  function swatch(val) {
    var m = est.peca && D.sw_peca && D.sw_peca[est.peca.h];
    if (m && m[val]) return m[val];
    return D.swatches[val] || null;
  }

  // ---- as perguntas de cada eixo, pelo papel que ele tem na peça ----------
  // O texto não descreve o eixo: descreve a DECISÃO. "Quem se senta aí" decide o
  // tecido melhor do que "escolha um tecido", porque é a pergunta que a pessoa
  // já tem na cabeça.
  var PERG = {
    tecido: {
      olho: 'O tecido', h: 'Quem é que vive com esta peça?',
      nota: 'A resposta decide o tecido. Não é uma questão de gosto — é de quanto ele vai levar.'
    },
    madeira: {
      olho: 'A madeira', h: 'A divisão é clara ou escura?',
      nota: 'O carvalho clareia, a nogueira assenta, o eucalipto fumado faz contraste.'
    },
    tamanho: { olho: 'O tamanho', h: 'De que tamanho precisa?', nota: 'Manda o colchão, ou a mesa que lá cabe.' },
    outro: { olho: '', h: '', nota: '' }
  };
  // Três opções que davam todas no mesmo tecido, com o mesmo quadrado ao lado,
  // não são três opções — são uma pergunta mal feita. O grupo é a decisão real
  // (aguenta ou não aguenta) e a cor é o que muda a fotografia. Por isso a
  // pergunta do tecido tem duas mãos no mesmo ecrã.
  var GRUPOS_TECIDO = [
    { k: 'pet', r: 'Crianças, animais, muita gente', n: 'Tecido que se limpa facilmente' },
    { k: 'solto', r: 'Só nós, com calma', n: 'O leque todo, sem restrição' }
  ];
  var TOM_ROT = { clara: 'Clara — quero manter a luz', escura: 'Escura — quero peso e conforto', contraste: 'Quero contraste' };


  // ---- onde é que a peça está dentro do quadrado -------------------------
  // Os renders de estúdio são quadrados e a peça ocupa metade deles: um sofá
  // baixo deixa dois terços de fundo por cima. Numa página que é toda
  // fotografia, isso é o mesmo que não a mostrar.
  //
  // Em vez de adivinhar um recorte por peça, mede-se: desenha-se a imagem
  // pequena num canvas, procura-se onde o fundo de estúdio deixa de ser liso, e
  // enquadra-se a janela na peça. O CDN da Shopify serve as imagens com
  // access-control-allow-origin, por isso dá para ler os pixéis.
  var cacheMedida = {};
  function medir(url, cb) {
    if (cacheMedida[url]) { cb(cacheMedida[url]); return; }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var caixa = null;
      try {
        var N = 140;
        var c = document.createElement('canvas');
        var e2 = Math.min(N / im.naturalWidth, N / im.naturalHeight);
        c.width = Math.max(4, Math.round(im.naturalWidth * e2));
        c.height = Math.max(4, Math.round(im.naturalHeight * e2));
        var g = c.getContext('2d', { willReadFrequently: true });
        g.drawImage(im, 0, 0, c.width, c.height);
        var d = g.getImageData(0, 0, c.width, c.height).data;
        function px(x, y) { var i = (y * c.width + x) * 4; return [d[i], d[i + 1], d[i + 2]]; }

        // O fundo do estúdio NÃO é liso: tem um degradê de cima para baixo e um
        // vinco de sombra em baixo. Comparar tudo com o pixel do canto marcava a
        // imagem inteira como peça. Cada linha traz o seu próprio fundo — os
        // pixéis das duas bordas dessa linha — e é com esse que se compara.
        var LIM = 90, MIN = 2;
        var x0 = c.width, y0 = c.height, x1 = -1, y1 = -1;
        for (var y = 0; y < c.height; y++) {
          var a = px(0, y), b2 = px(c.width - 1, y);
          var fr = (a[0] + b2[0]) / 2, fg = (a[1] + b2[1]) / 2, fb = (a[2] + b2[2]) / 2;
          var corrido = 0, pri = -1, ult = -1;
          for (var x = 0; x < c.width; x++) {
            var p3 = px(x, y);
            var dif = Math.abs(p3[0] - fr) + Math.abs(p3[1] - fg) + Math.abs(p3[2] - fb);
            if (dif > LIM) {
              corrido++;
              if (corrido >= MIN) { if (pri < 0) pri = x - corrido + 1; ult = x; }
            } else corrido = 0;
          }
          if (pri >= 0) {
            if (pri < x0) x0 = pri;
            if (ult > x1) x1 = ult;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
          }
        }
        // a sombra no chão conta como peça; um resultado que ocupe quase tudo
        // é sinal de que a medição falhou e não se mexe em nada.
        if (x1 > x0 && y1 > y0) {
          var fw = (x1 - x0 + 1) / c.width, fh = (y1 - y0 + 1) / c.height;
          if (fw < 0.995 || fh < 0.995) {
            caixa = { x0: x0 / c.width, y0: y0 / c.height, x1: (x1 + 1) / c.width, y1: (y1 + 1) / c.height };
          }
        }
      } catch (e) { caixa = null; }
      cacheMedida[url] = caixa || { x0: 0, y0: 0, x1: 1, y1: 1 };
      cb(cacheMedida[url]);
    };
    im.onerror = function () { cacheMedida[url] = { x0: 0, y0: 0, x1: 1, y1: 1 }; cb(cacheMedida[url]); };
    im.src = url;
  }

  // O que decide o enquadramento é a fracção da janela que a peça passa a
  // ocupar, não a proporção dela: uma estante alta e um sofá largo têm de
  // acabar os dois a encher a mesma janela.
  function enquadrar(im, caixa) {
    if (!caixa || !im) return;
    var fw = caixa.x1 - caixa.x0, fh = caixa.y1 - caixa.y0;
    if (fw <= 0 || fh <= 0) return;
    var cx = (caixa.x0 + caixa.x1) / 2, cy = (caixa.y0 + caixa.y1) / 2;
    var cxa = im.parentNode;

    // A moldura segue a peça. Um sofá de 3,5 m e uma estante de 2 m não cabem
    // na mesma janela quadrada: um fica minúsculo ao meio de fundo branco, a
    // outra fica cortada. O que decide é a proporção da PEÇA — medida, não a do
    // ficheiro — presa a limites para a página não saltar.
    var prop = fw / fh;
    if (!isFinite(prop) || prop <= 0) prop = 1;
    if (prop < 0.72) prop = 0.72;
    if (prop > 2.30) prop = 2.30;
    if (cxa) {
      cxa.style.aspectRatio = prop.toFixed(3);
      // presa ao topo, a caixa tem de deixar ver a pergunta: nunca mais de 40%
      // do ecrã, e é a fotografia que encolhe, não a peça que sai dela.
      var estreito = window.matchMedia('(max-width: 899px)').matches;
      cxa.style.maxHeight = estreito ? Math.round(window.innerHeight * 0.40) + 'px' : '';
    }

    // Com a moldura já do tamanho da peça, o recorte é 'cover' centrado nela, e
    // um empurrão pequeno para ela encher nove décimos da janela.
    im.style.objectFit = 'cover';
    im.style.objectPosition = (cx * 100).toFixed(1) + '% ' + (cy * 100).toFixed(1) + '%';
    var ocupa = prop >= 1 ? fw : fh;
    var k = 0.92 / ocupa;
    if (!isFinite(k) || k < 1) k = 1;
    if (k > 1.9) k = 1.9;
    im.style.transform = 'scale(' + k.toFixed(3) + ')';
  }

  // ---------------------------------------------------------------- desenho
  function topo(passo, total, titulo) {
    var t = '';
    if (total) {
      t = '<div class="qz__trilho">';
      for (var k = 0; k < total; k++) t += '<i class="' + (k <= passo ? 'on' : '') + '"></i>';
      t += '</div>';
    }
    return '<div class="qz__topo">' +
      '<button class="qz__atras" data-qz-atras' + (passo <= 0 && !est.peca ? ' hidden' : '') + '>' +
        '<svg width="13" height="9" viewBox="0 0 13 9" fill="none" aria-hidden="true">' +
        '<path d="M5 1 1.5 4.5 5 8M1.5 4.5H12" stroke="currentColor" stroke-width="1.2"/></svg>Voltar</button>' +
      '<span class="qz__conta">' + esc(titulo) + '</span></div>' + t;
  }

  function fotoAgora() {
    var p = est.peca;
    if (!p) return { url: null, sem: null };
    var chave = p.e.map(function (e) { return est.esc[e.n] || ''; }).join('|');
    var v = p.v[chave];
    if (v && v[3]) return { url: v[3], sem: null, var: v };
    // sem fotografia certa: dizemos qual é o acabamento que falta em vez de
    // mostrar outro. Hoje isto só acontece no Aqua.
    var falta = null;
    for (var i = 0; i < p.e.length; i++) {
      var val = est.esc[p.e[i].n];
      if (!val) continue;
      var algum = false;
      for (var k in p.v) { if (k.split('|')[i] === val && p.v[k][3]) { algum = true; break; } }
      if (!algum) { falta = val; break; }
    }
    return { url: p.fb, sem: falta, var: v };
  }

  var ultimaEsc = {};
  var relogioLegenda = null;
  function pintarLegenda() {
    var lg = palco.querySelector('[data-qz-legenda]');
    if (!lg || !est.peca) return;
    // Só aparece quando alguma coisa muda. Na primeira pintura de um ecrã não
    // há nada a confirmar, e uma barra a tapar a peça sem razão é ruído.
    var mudou = false, partes = [];
    est.peca.e.forEach(function (e) {
      var v = est.esc[e.n];
      if (!v) return;
      var esta = ultimaEsc[e.n] !== undefined && ultimaEsc[e.n] !== v;
      if (esta) mudou = true;
      partes.push('<span>' + esc(e.n) + '</span> <b class="' + (esta ? 'muda' : '') + '">' + esc(v) + '</b>');
    });
    est.peca.e.forEach(function (e) { ultimaEsc[e.n] = est.esc[e.n]; });
    if (!mudou || !partes.length) return;
    lg.innerHTML = partes.join('');
    lg.hidden = false;
    void lg.offsetWidth;
    lg.classList.add('vista');
    if (relogioLegenda) clearTimeout(relogioLegenda);
    relogioLegenda = setTimeout(function () { lg.classList.remove('vista'); }, 1400);
  }

  function pintarFoto() {
    var f = fotoAgora();
    pintarLegenda();
    var cx = palco.querySelector('[data-qz-foto-caixa]');
    if (!cx) return;
    var im = cx.querySelector('.qz__foto');
    var sem = cx.querySelector('.qz__sem');
    var am = cx.querySelector('.qz__amostra');
    if (im) {
      var novo = img(f.url, 1200);
      if (im.getAttribute('src') !== novo) {
        im.classList.add('a-trocar');
        var pre = new Image();
        pre.crossOrigin = 'anonymous';
        var mostrar = function () {
          im.src = novo;
          im.style.transform = '';
          medir(novo, function (cx2) { enquadrar(im, cx2); im.classList.remove('a-trocar'); });
        };
        pre.onload = mostrar; pre.onerror = mostrar;
        pre.src = novo;
      }
    }
    if (sem) {
      if (f.sem) {
        sem.innerHTML = '<b>' + esc(f.sem) + '</b> ainda não está fotografado nesta peça. ' +
          'É o mesmo desenho, neste tecido — que é o que está aqui ao lado.';
        sem.hidden = false;
      } else sem.hidden = true;
    }
    if (am) {
      var sw = f.sem && swatch(f.sem);
      if (sw) { am.src = sw; am.alt = f.sem; am.hidden = false; } else am.hidden = true;
    }
  }

  function caixaFoto() {
    var f = fotoAgora();
    setTimeout(function () {
      var im = palco.querySelector('.qz__foto');
      if (im) medir(im.src, function (cx2) { enquadrar(im, cx2); });
    }, 0);
    return '<div class="qz__foto-caixa" data-qz-foto-caixa>' +
      '<img class="qz__foto" src="' + esc(img(f.url, 1200)) + '" alt="' + esc(est.peca ? est.peca.n : '') + '">' +
      '<img class="qz__amostra" hidden alt="">' +
      '<p class="qz__legenda" data-qz-legenda hidden></p>' +
      '<p class="qz__sem" hidden></p></div>';
  }

  // ------------------------------------------------------------------ ecrãs
  function ecraDivisao() {
    est.peca = null; est.esc = {}; est.i = 0;
    var divs = [
      ['Sala', 'Onde se está ao fim do dia'],
      ['Quarto', 'Onde se dorme e se acorda'],
      ['Jantar', 'Onde se recebe'],
      ['Hall', 'A primeira coisa que se vê']
    ];
    var h = topo(-1, 0, 'Passo 1 de 2') +
      '<div class="qz__perg" style="max-width:640px;margin:clamp(20px,4vw,44px) auto 0;text-align:center">' +
      '<p class="qz__olho">Cinco minutos</p>' +
      '<h1 class="qz__h">Que divisão está a resolver?</h1>' +
      '<p class="qz__nota" style="margin-left:auto;margin-right:auto">Não vamos perguntar o seu estilo. ' +
      'Vamos mostrar-lhe a peça a mudar enquanto responde.</p>' +
      '<div class="qz__ops qz__ops--grelha" style="margin-top:26px">';
    divs.forEach(function (d) {
      h += '<button class="qz__op" data-div="' + esc(d[0]) + '"><span class="qz__op-txt">' +
        '<b>' + esc(d[0]) + '</b><span>' + esc(d[1]) + '</span></span></button>';
    });
    h += '</div></div>';
    palco.innerHTML = h;
    palco.querySelectorAll('[data-div]').forEach(function (b) {
      b.addEventListener('click', function () { est.div = b.dataset.div; ecraPeca(); });
    });
  }

  function ecraPeca() {
    aoTopo();
    var lista = D.pecas.filter(function (p) { return p.d.indexOf(est.div) > -1; });
    // as que estão inteiramente fotografadas primeiro: são as que o quiz
    // consegue percorrer sem nunca dizer "ainda não temos".
    lista.sort(function (a, b) {
      function cheia(p) { var n = 0, t = 0; for (var k in p.v) { t++; if (p.v[k][3]) n++; } return t ? n / t : 0; }
      return cheia(b) - cheia(a);
    });
    var h = topo(-1, 0, 'Passo 2 de 2 · ' + est.div) +
      '<div class="qz__perg" style="margin-top:clamp(18px,3vw,32px)">' +
      '<p class="qz__olho">' + esc(est.div) + '</p>' +
      '<h1 class="qz__h">O que é que falta lá?</h1>' +
      '<p class="qz__nota">A partir daqui é ela que responde às perguntas.</p></div>' +
      '<div class="qz__pecas" style="margin-top:20px">';
    lista.forEach(function (p) {
      var qualquer = null;
      for (var k in p.v) { if (p.v[k][3]) { qualquer = p.v[k][3]; break; } }
      var pr = null;
      for (var k2 in p.v) { pr = pr === null ? p.v[k2][1] : Math.min(pr, p.v[k2][1]); }
      h += '<button class="qz__peca" data-peca="' + esc(p.h) + '">' +
        '<img loading="lazy" src="' + esc(img(qualquer || p.fb, 600)) + '" alt="' + esc(p.n) + '">' +
        '<span class="qz__peca-pe"><b>' + esc(p.n) + '</b><span>desde ' + euros(pr) + '</span></span></button>';
    });
    h += '</div>';
    palco.innerHTML = h;
    ligarAtras(ecraDivisao);
    palco.querySelectorAll('[data-peca]').forEach(function (b) {
      b.addEventListener('click', function () {
        est.peca = D.pecas.filter(function (p) { return p.h === b.dataset.peca; })[0];
        est.esc = {}; est.i = 0; ultimaEsc = {};
        // arranca no estado que a peça tem por omissão: o primeiro valor de cada eixo
        est.peca.e.forEach(function (e) { est.esc[e.n] = e.v[0]; });
        ecraEixo();
      });
    });
  }

  function grupoDe(e, val) {
    return D.petproof.indexOf(val) > -1 ? 'pet' : 'solto';
  }
  function coresDoGrupo(e, k) {
    return e.v.filter(function (v) {
      return (D.petproof.indexOf(v) > -1) === (k === 'pet');
    });
  }
  function opcoesDoEixo(e) {
    if (e.p === 'madeira') {
      return e.v.map(function (v) { return { val: v, rot: TOM_ROT[D.tom[v]] || v, nota: v }; });
    }
    return e.v.map(function (v) { return { val: v, rot: v, nota: '' }; });
  }

  function ecraEixo() {
    aoTopo();
    var p = est.peca, e = p.e[est.i];
    var total = p.e.length + 1;
    var cfg = PERG[e.p] || PERG.outro;
    var titulo = cfg.h || ('Escolha ' + e.n.toLowerCase());
    var nota = cfg.nota || '';

    var corpo = '';
    if (e.p === 'tecido') {
      var kAtual = grupoDe(e, est.esc[e.n]);
      corpo = '<div class="qz__ops">';
      GRUPOS_TECIDO.forEach(function (g) {
        if (!coresDoGrupo(e, g.k).length) return;
        corpo += '<button class="qz__op" data-grupo="' + g.k + '" aria-pressed="' +
          (kAtual === g.k ? 'true' : 'false') + '"><span class="qz__op-txt">' +
          '<b>' + esc(g.r) + '</b><span>' + esc(g.n) + '</span></span></button>';
      });
      corpo += '</div><p class="qz__olho" style="margin:22px 0 10px">E qual deles</p>' +
        '<div class="qz__cores" data-qz-cores></div>';
    } else {
      corpo = '<div class="qz__ops">';
      opcoesDoEixo(e).forEach(function (o) {
        var sw = swatch(o.val);
        corpo += '<button class="qz__op" data-val="' + esc(o.val) + '" aria-pressed="' +
          (est.esc[e.n] === o.val ? 'true' : 'false') + '">' +
          (sw ? '<img class="qz__op-sw" src="' + esc(sw) + '" alt="" loading="lazy">' : '') +
          '<span class="qz__op-txt"><b>' + esc(o.rot) + '</b>' +
          (o.nota && o.nota !== o.rot ? '<span>' + esc(o.nota) + '</span>' : '') +
          '</span></button>';
      });
      corpo += '</div>';
    }

    palco.innerHTML = topo(est.i, total, p.n + ' · ' + (est.i + 1) + ' de ' + total) +
      '<div class="qz__obra">' + caixaFoto() +
      '<div class="qz__perg"><p class="qz__olho">' + esc(cfg.olho || e.n) + '</p>' +
      '<h1 class="qz__h">' + esc(titulo) + '</h1>' +
      (nota ? '<p class="qz__nota">' + esc(nota) + '</p>' : '') + corpo +
      '<div class="qz__bts"><button class="qz__bt" data-qz-seguinte>' +
      (est.i === p.e.length - 1 ? 'Falta o prazo' : 'Seguinte') + '</button></div></div></div>';

    ligarAtras(function () { if (est.i === 0) ecraPeca(); else { est.i--; ecraEixo(); } });

    function pintarCores() {
      var cx = palco.querySelector('[data-qz-cores]');
      if (!cx) return;
      var k = grupoDe(e, est.esc[e.n]);
      var cores = coresDoGrupo(e, k);
      cx.innerHTML = cores.map(function (v) {
        var sw = swatch(v);
        return '<button class="qz__cor" data-val="' + esc(v) + '" aria-pressed="' +
          (est.esc[e.n] === v ? 'true' : 'false') + '" title="' + esc(v) + '">' +
          (sw ? '<img src="' + esc(sw) + '" alt="" loading="lazy">' : '<span class="qz__cor-vazia"></span>') +
          '<span>' + esc(v) + '</span></button>';
      }).join('');
      cx.querySelectorAll('[data-val]').forEach(function (b) {
        b.addEventListener('click', function () {
          est.esc[e.n] = b.dataset.val;
          cx.querySelectorAll('[data-val]').forEach(function (o) {
            o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
          });
          pintarFoto();
        });
      });
    }

    palco.querySelectorAll('[data-grupo]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cores = coresDoGrupo(e, b.dataset.grupo);
        if (!cores.length) return;
        est.esc[e.n] = cores[0];
        palco.querySelectorAll('[data-grupo]').forEach(function (o) {
          o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
        });
        pintarCores(); pintarFoto();
      });
    });
    palco.querySelectorAll('.qz__ops [data-val]').forEach(function (b) {
      b.addEventListener('click', function () {
        est.esc[e.n] = b.dataset.val;
        palco.querySelectorAll('.qz__ops [data-val]').forEach(function (o) {
          o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
        });
        pintarFoto();
      });
    });
    palco.querySelector('[data-qz-seguinte]').addEventListener('click', function () {
      if (est.i === p.e.length - 1) ecraPrazo(); else { est.i++; ecraEixo(); }
    });
    pintarCores();
    pintarFoto();
  }

  function ecraPrazo() {
    aoTopo();
    var p = est.peca, total = p.e.length + 1;
    var ops = [
      ['ja', 'Nas próximas 4 semanas', 'Preciso dela depressa'],
      ['medio', 'Daqui a 1 a 3 meses', 'Tenho tempo, mas tenho data'],
      ['calma', 'Sem pressa', 'Quero é que fique bem']
    ];
    var h = topo(total - 1, total, p.n + ' · ' + total + ' de ' + total) +
      '<div class="qz__obra">' + caixaFoto() +
      '<div class="qz__perg"><p class="qz__olho">O prazo</p>' +
      '<h1 class="qz__h">Para quando precisa dela?</h1>' +
      '<p class="qz__nota">Esta não muda a peça. Muda o que lhe propomos a seguir — ' +
      'e é a única que preferimos fazer agora do que no fim.</p><div class="qz__ops">';
    ops.forEach(function (o) {
      h += '<button class="qz__op" data-prazo="' + o[0] + '"><span class="qz__op-txt">' +
        '<b>' + esc(o[1]) + '</b><span>' + esc(o[2]) + '</span></span></button>';
    });
    h += '</div></div></div>';
    palco.innerHTML = h;
    ligarAtras(function () { est.i = p.e.length - 1; ecraEixo(); });
    palco.querySelectorAll('[data-prazo]').forEach(function (b) {
      b.addEventListener('click', function () {
        est.prazo = b.dataset.prazo; ecraFim();
      });
    });
    pintarFoto();
  }

  function janela(semanas) {
    if (!semanas) return null;
    var a = new Date(), b = new Date();
    a.setDate(a.getDate() + semanas * 7);
    b.setDate(b.getDate() + (semanas + 1) * 7);
    var f = function (d) { return d.toLocaleDateString('pt-PT', { day: 'numeric', month: 'long' }); };
    return f(a) + ' e ' + f(b);
  }

  function ecraFim() {
    aoTopo();
    var p = est.peca;
    var chave = p.e.map(function (e) { return est.esc[e.n] || ''; }).join('|');
    var v = p.v[chave];
    var f = fotoAgora();
    var win = janela(p.s);
    var depressa = est.prazo === 'ja' && p.s && p.s > 4;

    var linhas = p.e.map(function (e) {
      return '<div><span class="r">' + esc(e.n) + '</span><span class="v">' + esc(est.esc[e.n]) + '</span></div>';
    }).join('');

    var h = topo(0, 0, p.n + ' · a sua') +
      '<div class="qz__obra">' + caixaFoto() +
      '<div class="qz__perg">' +
      '<p class="qz__olho">A sua ' + esc(p.n) + '</p>' +
      '<h1 class="qz__h">Esta existe. Não é uma sugestão.</h1>' +
      (v ? '<div class="qz__linha-preco"><p class="qz__preco">' + euros(v[1]) + '</p>' +
        (v[2] ? '<button class="qz__bt qz__bt--comprar" data-qz-carrinho data-id="' + esc(v[0]) +
                '">Adicionar ao carrinho</button>' : '') + '</div>' : '') +
      (win ? '<p class="qz__data">Em sua casa entre <b>' + esc(win) + '</b>' +
        (p.s ? ' — ' + p.s + ' semanas de marcenaria, com uma de margem.' : '') + '</p>' : '') +
      '<div class="qz__res-linhas">' + linhas +
      (p.m ? '<div><span class="r">Medidas</span><span class="v">' + esc(p.m.split('·')[0].split('—')[0].trim()) + '</span></div>' : '') +
      '</div>';

    if (depressa) {
      h += '<p class="qz__medida">Disse que precisa dela em menos de um mês, e esta leva ' + p.s +
        ' semanas a fazer. Não vamos fingir que dá. Ou lhe mostramos o que sai mais depressa, ' +
        'ou guardamos esta para quando fizer sentido.</p>';
    }

    h += '<div class="qz__bts">' +
      '<a class="qz__bt qz__bt--calmo" href="' + esc(p.u) + '">Ver a ficha</a>' +
      '<button class="qz__bt qz__bt--calmo" data-qz-recomecar>Outra peça</button>' +
      '</div>';

    if (f.sem) {
      h += '<p class="qz__medida">O ' + esc(f.sem) + ' é o tecido pensado para casas com animais, e é ' +
        'o que lhe recomendamos aqui. A peça neste tecido está a ser fotografada — ' +
        'o tecido em si é o quadrado que está na imagem.</p>';
    }
    h += '</div></div>';
    palco.innerHTML = h;
    ligarAtras(ecraPrazo);
    var bt = palco.querySelector('[data-qz-carrinho]');
    if (bt) bt.addEventListener('click', function () {
      bt.disabled = true; bt.textContent = 'A adicionar…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(bt.dataset.id), quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { bt.disabled = false; bt.textContent = 'Adicionar ao carrinho'; });
    });
    var re = palco.querySelector('[data-qz-recomecar]');
    if (re) re.addEventListener('click', function () { ecraDivisao(); });
    pintarFoto();
  }

  function aoTopo() {
    var y = raiz.getBoundingClientRect().top + window.pageYOffset - 12;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
  }

  function ligarAtras(fn) {
    var b = palco.querySelector('[data-qz-atras]');
    if (b) b.addEventListener('click', function () { fn(); });
  }

  fetch(raiz.dataset.dados)
    .then(function (r) { return r.json(); })
    .then(function (d) {
      D = d;
      carga.hidden = true; palco.hidden = false;
      ecraDivisao();
    })
    .catch(function () {
      carga.innerHTML = '<p style="font-family:var(--base-font-family);opacity:.6">' +
        'Não foi possível carregar. Recarregue a página, por favor.</p>';
    });
})();
